import { useEffect, useState } from "react";
import InputField from "../../components/Forms/Input/InputField";
import SelectField from "../Forms/Input/SelectField";

import { useCashSession } from "../../hooks/cash/useCashSession";
import { useCashRegister } from "../../hooks/cash/useCashRegister";

const CashOpeningForm = () => {
  const {
    openingForm,
    setRegister,
    toggleCounting,
    getSessionStatus,
    isCountingCash,
    updateOpeningAmount,
    resetOpeningAmountAndDetails,
    error,
  } = useCashSession();

  const { dropdown, fetchDropdown } = useCashRegister();

  const [amountInput, setAmountInput] = useState("0.00");
  const [amountError, setAmountError] = useState("");

  /**
   * sincronizar con redux
   */
  useEffect(() => {
    setAmountInput(openingForm.openingAmount.toFixed(2));
  }, [openingForm.openingAmount]);

  /**
   * 🔄 Cargar terminales POS
   */
  useEffect(() => {
    fetchDropdown();
  }, []);

  const registers = dropdown.map((r: any) => ({
    value: r.id,
    label: r.name
  }));

  /**
   * Cambio de terminal
   */
  const handleSelectChange = async (value: string) => {
    const registerId = Number(value);

    setRegister(registerId);
    resetOpeningAmountAndDetails();
    setAmountInput("0.00");
    setAmountError("");

    await getSessionStatus(registerId);
  };

  /**
   * activar conteo
   */
  const handleActivateCount = () => {
    if (!openingForm.registerId) {
      setAmountError("Seleccione una terminal POS antes de contar efectivo");
      return;
    }

    setAmountError("");
    resetOpeningAmountAndDetails();
    setAmountInput("0.00");

    toggleCounting();
  };

  return (
    <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-black dark:text-white">
          Apertura de Caja
        </h3>

        <button
          type="button"
          onClick={handleActivateCount}
          className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700"
        >
          {isCountingCash ? "Usar monto manual" : "Contar efectivo"}
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <SelectField
          label="Terminal POS"
          name="registerId"
          iconKey="store"
          value={openingForm.registerId ? String(openingForm.registerId) : ""}
          onChange={(e: any) => handleSelectChange(e.target.value)}
          options={registers}
          placeholder="Seleccione una terminal"
          required
          error={error}
        />

        <InputField
          label="Monto inicial"
          name="openingAmount"
          type="number"
          step="0.01"
          min={0}
          iconKey="dollar"
          value={amountInput}
          disabled={isCountingCash}
          error={amountError}
          onFocus={() => {
            setAmountError("");

            if (amountInput === "0.00") {
              setAmountInput("");
            }
          }}
          onChange={(e: any) => {
            const value = e.target.value;
            setAmountInput(value);
            setAmountError("");
          }}
          onBlur={() => {
            if (amountInput === "") {
              setAmountInput("0.00");
              updateOpeningAmount(0);
              return;
            }

            const parsed = parseFloat(amountInput);

            if (!isNaN(parsed)) {
              const formatted = parsed.toFixed(2);
              setAmountInput(formatted);
              updateOpeningAmount(parsed);
            } else {
              setAmountInput("0.00");
              updateOpeningAmount(0);
            }
          }}
        />
      </div>
    </div>
  );
};

export default CashOpeningForm;